/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Tab_DealsInputs */

const cs_pipelines_tab_deals = /** @type {(inputs: Pipelines_Tab_DealsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obchody`)
};

const en_pipelines_tab_deals = /** @type {(inputs: Pipelines_Tab_DealsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deals`)
};

/**
* | output |
* | --- |
* | "Deals" |
*
* @param {Pipelines_Tab_DealsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_tab_deals = /** @type {((inputs?: Pipelines_Tab_DealsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Tab_DealsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_tab_deals(inputs)
	return cs_pipelines_tab_deals(inputs)
});